import axios from "axios";

export const vendorTaxDetailV2 = async (
  setFormState,
  vendor_Code,
  invoice_Amount
) => {
  // setTaxCardLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getVendorTaxDetail/${vendor_Code}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      let responseData = [];
      for (let index = 0; index < res?.data?.taxDetail?.length; index++) {
        const element = res?.data?.taxDetail[index];
        const obj = {
          category: element?.category,
          purchaseType: element?.purchaseType,
          supplierJurisdiction: element?.supplierJurisdiction,
          supplierType: element?.supplierType,
          status: element?.status,
          fillingStatus: element?.fillingStatus,
          goodsNature: element?.goodsNature,
          taxType: element?.taxType,
          taxCode: element?.taxCode,
          amount: invoice_Amount,
        };

        responseData.push(obj);
      }
      const tempObj = {
        category: "",
        purchaseType: "",
        supplierJurisdiction: "",
        supplierType: "",
        status: "",
        fillingStatus: "",
        goodsNature: "",
        taxType: "",
        taxCode: "",
        amount: invoice_Amount,
      };

      const finded = res.data?.vendorTax[0];
      const isTaxAmt = isNaN(Number(finded?.salesTaxAmount));
      setFormState((formState) => ({
        ...formState,
        salesTaxCode: formState.salesTaxCode==""?finded?.salesTaxCode?.split(" ")?.[0]:formState.salesTaxCode || "",
        salesTaxAmount: isTaxAmt ? "" : formState?.salesTaxAmount!==""?formState?.salesTaxAmount:finded?.salesTaxAmount || "",
        taxCard_List: formState?.taxCard_List?.length>0?formState?.taxCard_List:responseData?.length > 0 ? responseData : [tempObj],
        taxCard_ListCheck: responseData?.length > 0 ? responseData : [tempObj], // this is stored to check, Is there data of tax of that vendor.
      }));
      // setTaxCardLoading(false);
    })
    .catch((err) => {
      // setTaxCardLoading(false);
    });
};

export const getTaxCodeWithBlock = async (
  setTaxCodeList,
  setTaxCodeListLoading,
  setWhCodes,
  setStCodes
) => {
  const taxCode = localStorage.getItem("getTaxCodeBlock");
  // if (!taxCode) {
  setTaxCodeListLoading(true);
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getTaxCodeV2`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      const whCodes = [];
      const stCodes = [];
      res.data.forEach((item) => {
        if (item.TaxType == "WHT") whCodes.push(item);
        else if (item.TaxType == "ST")
          stCodes.push(item.S_TAX_CODE + " - " + item.DESCRIPTION);
      });
      setWhCodes(whCodes);
      setStCodes(stCodes);
      setTaxCodeList(res.data);
      localStorage.setItem("getTaxCodeBlock", JSON.stringify(res.data));
      // setTaxCodeList(res.data);

      setTaxCodeListLoading(false);
    })
    .catch((err) => {
      setTaxCodeListLoading(false);
    });
};

export const sapVendorTaxDetail = async (
  setFormState,
  vendor_Code,
  setTaxType_list
) => {
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/sap-endpoint/vendor-tax-detail/${vendor_Code}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      const taxTypeList = res.data.map((i) => {
        return i.Tax_Type + " - " + i.Description;
      });
      setTaxType_list(taxTypeList);
      setFormState((formState) => ({
        ...formState,
        vendor_tax_detail: res.data.Message ? [] : res.data,
        cnic: res.data?.[0]?.CNIC,
        ntn: res.data?.[0]?.NTN,
      }));
      // setCount(parseInt(res?.data?.vendor_tax_detail[0].TotalNumberOfRecords))
    })
    .catch((err) => {});
};
